var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mfu-module"},[_c('ButtonGroup',[_c('Button',{on:{"click":function($event){return _vm.uploadFiles(true)}}},[_vm._v(_vm._s(_vm.def.Labels.UploadButton))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }